import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/home/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/home',
    meta: {
      title: '我的闪送值'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/record/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/record',
    meta: {
      title: '闪送值记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/explain/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/explain',
    meta: {
      title: '闪送值说明'
    }
  },

  // 闪送值v2版
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/v2/valueHome/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/v2/valueHome',
    meta: {
      title: '闪送值'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/v2/valueList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/v2/valueList',
    meta: {
      title: '活跃分明细'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/v2/valueDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/v2/valueDetail',
    meta: {
      title: '闪送值详情'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/v2/ruleInfo/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/v2/ruleInfo',
    meta: {
      title: '当日计算规则'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/v2/explainInfo/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/v2/explainInfo',
    meta: {
      title: '闪送值说明'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/v2/howToImprove/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/v2/howToImprove',
    meta: {
      title: '如何提升'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/shansongValue/v2/sign/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/shansongValue/v2/sign',
    exact: true,
    meta: {
      title: '闪送'
    }
  }
]
